import { KeyboardEvent, useState } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { defaultPRD3050_R01Filter, usePRD3050_R01Store } from "./Store_PRD3050_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchSection_PRD3050_R01 = (props: Props) => {

	const { onEnterKeyDown } = props;

    const { setCodeSearchModalProps } = useUiuxStore();
	const { PRD3050_R01Filter, setPRD3050_R01Filter } = usePRD3050_R01Store();
	const { compCdList, workPlaceList, jobTeamList, yesNoList } = useCommonCodeStore();

	
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	const handleWorkEmpFoucsId = 'workEmp_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'workEmp',
			category: '작업자',
			focusId: handleWorkEmpFoucsId,
			responseMapping: {
				empNo: 'workEmp',
				empNm: 'workEmpNm',
			},
			extraFilter: () => ({
				workEmp: PRD3050_R01Filter.workEmp || '',
				workEmpNm: PRD3050_R01Filter.workEmpNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD3050_R01Filter,
		setEditData: setPRD3050_R01Filter,
		defaultData: defaultPRD3050_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD3050_R01_search'
	});

	return (
		<SearchSectionDoubleForm >
			{/* PRD2020Filter : {JSON.stringify(PRD3050_R01Filter)} <br /> */}
			<SearchDropDownForm
				label="사업장"
				value={PRD3050_R01Filter.compCd}
				onChangeItem={(item) => setPRD3050_R01Filter({ compCd: item?.compCd || ''})}
				optionList={compCdList}
			/>
			<SearchMonthSingleForm
				label="생산년월"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={PRD3050_R01Filter.yearMonth ? new Date(PRD3050_R01Filter.yearMonth) : undefined}
				editable={true}
				onChange={(date) => setPRD3050_R01Filter({
					yearMonth: date ? formatDateYear4(date) + '-' + formatDateMonth(date) : '',
				})}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label="작업공정"
				value={PRD3050_R01Filter.workplaceCd}
				onChangeItem={(item) => setPRD3050_R01Filter({ workplaceCd: item?.workplaceCd || ''})}
				optionList={workPlaceList.filter(opt => opt.compCd === PRD3050_R01Filter.compCd)}
				editable={PRD3050_R01Filter.compCd !== ''}
			/>
			<SearchCodeModalForm
				label="작업자"
				value={PRD3050_R01Filter.workEmp}
				valueLabel={PRD3050_R01Filter.workEmpNm}
				handleFoucsId={handleWorkEmpFoucsId}
				onChange={getFieldHandlers('workEmp').onChange}
				onDoubleClick={getFieldHandlers('workEmp').onDoubleClick}
				onKeyDown={getFieldHandlers('workEmp').onEnterKeyDown}
				wrapperOption={{
					wrapperStyle: "w-[300px] min-w-[300px] mr-[10px]",
					titleStyle: "w-[40px] min-w-[40px] text-left",
					codeInputStyle: "w-[100px] min-w-[100px]",
					nameTagStyle: "w-[150px] min-w-[150px] text-left",
				}}
			/>
		</SearchSectionDoubleForm>
	);
};